import classNames from 'classnames';
import React from 'react';
import styles from './TabGroup.module.scss';

interface Props {
  className?: string | null | undefined;
  children: React.ReactNode;
}
const TabGroup = (props: Props) => {
  return (
    <div data-testid="tabs" className={classNames(styles.container, props.className)}>
      {props.children}
    </div>
  );
};

export default TabGroup;
